module.exports = __webpack_public_path__ + "img/ring_advisory_with_heart@2x.826b83c.jpg";